import { useSyncExternalStore } from "react";

// Interface sounds (boot chirp, module tick) and their per-device mute.
// The panic alarm is NOT covered by this switch: a muted interface must still
// sound a real panic. Everything is synthesized with Web Audio; no fetches.

const KEY = "br.sfx";
let muted = readMuted();
const listeners = new Set<() => void>();

function readMuted(): boolean {
  try {
    return window.localStorage.getItem(KEY) === "off";
  } catch {
    return false;
  }
}

export function setSoundMuted(next: boolean): void {
  muted = next;
  try {
    if (next) window.localStorage.setItem(KEY, "off");
    else window.localStorage.removeItem(KEY);
  } catch {
    // Storage blocked: the choice lasts for this page only.
  }
  listeners.forEach((l) => l());
}

export function soundMuted(): boolean {
  return muted;
}

export function useSoundMuted(): boolean {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => muted,
    () => muted,
  );
}
